import React, { Component } from 'react'
import {
  removeHtmlTags,
  strLimit,
  textTranslation,
  shouldTranslateTo,
} from '../../utils/utils'
import { Link } from 'react-router-dom'
import { decode } from 'html-entities'
import { withAuth } from '../AuthContext'

class Blog extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      error: {},
      blogData: null,
      featured: {},
      posts: [],
      postsDisplay: null,
      featuredTitleDisplay: '',
      featuredBodyDisplay: '',
      postTitles: [],
      postBodies: [],
      categories: [],
      activeCategory: null,
    }

    this.loadPosts = this.loadPosts.bind(this)
    this.handleLoadPosts = this.handleLoadPosts.bind(this)
  }

  async getTranslation(
    featureTitle,
    featureBody,
    postTitles,
    postBodies,
    pageData,
    languageValue
  ) {
    console.log('getTranslation - postTitles: ' + postTitles)
    console.log('getTranslation - postBodies: ' + postBodies)
    console.log('getTranslation - pageData: ' + pageData)
    console.log('getTranslation - languageValue: ' + languageValue)
    const translatedFeatureTitle = featureTitle
      ? await textTranslation(featureTitle, languageValue)
      : null
    const translatedFeatureBody = featureBody
      ? await textTranslation(featureBody, languageValue)
      : null
    const translatedPostTitles = postTitles
      ? await textTranslation(postTitles, languageValue)
      : null
    const translatedPostBodies = postBodies
      ? await textTranslation(postBodies, languageValue)
      : null
    const translatedPageData = pageData
      ? await textTranslation(pageData, languageValue)
      : null

    if (translatedFeatureTitle) {
      this.setState({
        featuredTitleDisplay: translatedFeatureTitle,
      })
    }

    if (translatedFeatureBody) {
      this.setState({
        featuredBodyDisplay: translatedFeatureBody,
      })
    }

    if (translatedPostTitles && translatedPostBodies) {
      this.state.posts.map((item, index) => {
        item.title = decode(translatedPostTitles[index])
        item.body = decode(translatedPostBodies[index])
      })

      console.log('getTranslation -> this.state.posts: ' + this.state.posts)

      this.setState({
        postsDisplay: this.state.posts,
      })
    }

    if (translatedPageData) {
      this.setState({
        blogData: translatedPageData,
      })
    }
  }

  async componentDidMount() {
    var pageData = [
      'Freebird wisdom',
      'Our articles offer advice on how to prepare for your trip, and how to stay safe and healthy while you' +
        decode('&#39;') +
        're on the go. We also feature stories and experiences from older travelers who have been there and done that, to help you make the most of your travels.',
      'Featured story',
      'All articles',
      'Read article',
      'minute read',
      'No posts found',
    ]
    try {
      const response = await axios.get(`/api/blog-post-categories`)
      this.setState({
        categories: response.data.data,
      })
    } catch (e) {
      this.setState({
        error: e,
      })
    } finally {
      this.setState({
        loading: false,
      })
    }

    try {
      const response = await axios.get(`/api/blog/featured`)
      this.setState(
        {
          featured: response.data.data,
        },
        () => {
          const shouldTranslateLang = shouldTranslateTo()
          if (shouldTranslateLang == 'xxx') {
            console.log('aaaaaa')
            this.getTranslation(
              this.state.featured.title,
              this.state.featured.body,
              null,
              null,
              pageData,
              shouldTranslateLang
            ),
              () => {
                console.log('bbbbbb')
                this.loadPosts()
              }
          } else {
            this.setState(
              {
                featuredTitleDisplay: this.state.featured.title,
                featuredBodyDisplay: this.state.featured.body,
                blogData: pageData,
              },
              () => {
                console.log(
                  '>>> blogData: ' + JSON.stringify(this.state.blogData)
                )
                console.log(
                  '>>> featuredTitleDisplay: ' +
                    JSON.stringify(this.state.featuredTitleDisplay)
                )
                this.loadPosts()
              }
            )
          }
        }
      )
    } catch (e) {
      this.setState({
        error: e,
      })
    } finally {
      this.setState({
        loading: false,
      })
    }
  }

  async loadPosts(categoryId = null) {
    console.log('loadPosts')
    this.setState({ loading: true })
    try {
      let response = null
      if (categoryId) {
        response = await axios.get(`/api/blog/category/${categoryId}`)
      } else {
        response = await axios.get(`/api/blog`)
      }

      this.setState(
        {
          posts: response.data.data,
        },
        () => {
          this.state.posts.map((item) => {
            this.state.postTitles.push(item.title)
            this.state.postBodies.push(item.body)
          })

          const shouldTranslateLang = shouldTranslateTo()
          if (shouldTranslateLang != 'en') {
            this.getTranslation(
              null,
              null,
              this.state.postTitles,
              this.state.postBodies,
              null,
              shouldTranslateLang
            )
          } else {
            console.log('loadPosts -> this.state.posts: ' + this.state.posts)
            this.setState({
              postsDisplay: this.state.posts,
            })
          }
        }
      )
    } catch (e) {
      this.setState({
        error: e,
      })
    } finally {
      this.setState({
        loading: false,
      })
    }
  }

  handleLoadPosts(e, categoryId) {
    e.preventDefault()
    this.setState({ activeCategory: categoryId })
    this.loadPosts(categoryId)
  }

  render() {
    console.log('*************************** render')
    console.log(
      'this.state.postsDisplay: ' + JSON.stringify(this.state.postsDisplay)
    )
    console.log(
      'this.state.featuredTitleDisplay: ' +
        JSON.stringify(this.state.featuredTitleDisplay)
    )
    console.log(
      'this.state.featuredBodyDisplay: ' +
        JSON.stringify(this.state.featuredBodyDisplay)
    )
    console.log('this.state.blogData: ' + JSON.stringify(this.state.blogData))

    if (
      !this.state.postsDisplay ||
      !this.state.featuredTitleDisplay ||
      !this.state.featuredBodyDisplay ||
      !this.state.blogData ||
      this.state.postsDisplay.length === 0 ||
      this.state.featuredTitleDisplay.length === 0 ||
      this.state.featuredBodyDisplay.length === 0 ||
      this.state.blogData.length === 0
    ) {
      return (
        <div className="card-body text-center">
          <div
            className="spinner-border homestays-spinner"
            style={{ marginTop: '100px' }}
            role="status"
          >
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      )
    }

    const auth = this.props.auth.user
    const that = this
    const menuCategories = this.state.categories.map(function (category) {
      return (
        <li
          className={`nav-item ${
            that.state.activeCategory === category.id ? 'active' : ''
          }`}
          key={category.id}
        >
          <a
            className={`nav-link ${
              that.state.activeCategory === category.id ? 'active' : ''
            }`}
            href="#"
            onClick={(e) => that.handleLoadPosts(e, category.id)}
          >
            {category.name}
          </a>
        </li>
      )
    })
    return (
      <section id="blog" className={`contact-wrapper main-wrapper`}>
        <div className="container">
          <div className="row pb-2 pb-md-5 featured-post">
            <div className="col-12 col-md-6">
              <h1
                className="font-all-round font-weight-600 font-size-64 text-black pb-3"
                style={{ width: '80%' }}
              >
                {decode(this.state.blogData[0])}
              </h1>
              <p className="font-open-sans font-weight-400 font-size-16 text-black">
                {decode(this.state.blogData[1])}
              </p>
            </div>
            <div className="col-12 col-md-6">
              {/*<img className="card-img-top" src="/images/blog/image.png" alt="Card image cap"/>*/}
              <div
                className="featured-image"
                style={{
                  backgroundImage: `url("${s3AwsEndpoint}/${this.state.featured.cover}")`,
                }}
              ></div>
              <p className="text-black font-all-round font-weight-600 font-size-20 pt-3">
                <i className="fa fa-star font-size-14"></i>{' '}
                {decode(this.state.blogData[2])}
              </p>
              <Link to={`/post/${this.state.featured.id}`}>
                <h4 className="text-black font-all-round font-weight-600 font-size-34">
                  {this.state.featuredTitleDisplay}
                </h4>
              </Link>
            </div>
          </div>
          <div className="row pt-2 pt-md-5 pb-3">
            <div className="col-12">
              <div className="row d-flex justify-content-center blog-navigation px-3">
                <ul className="nav">
                  <li
                    className={`nav-item ${
                      !this.state.activeCategory ? 'active' : ''
                    }`}
                  >
                    <a
                      className={`nav-link ${
                        !this.state.activeCategory ? 'active' : ''
                      }`}
                      aria-current="page"
                      href="#"
                      onClick={(e) => that.handleLoadPosts(e, null)}
                    >
                      {decode(this.state.blogData[3])}
                    </a>
                  </li>
                  {menuCategories}
                </ul>
              </div>
            </div>
          </div>
          <div className="row">
            {this.state.posts.length > 0 ? (
              this.state.postsDisplay.map((postsDisplay) => {
                return (
                  <div
                    className="card-post col-12 col-md-4"
                    key={postsDisplay.id}
                    style={{ width: '100%' }}
                    onClick={() =>
                      that.props.history.push(`/post/${postsDisplay.id}`)
                    }
                  >
                    <div className="card border-0">
                      {/*<img className="card-img-top" src="/images/blog/post-rectangle.png" alt="Card image cap"/>*/}
                      <div
                        className="post-image"
                        style={{
                          backgroundImage: `url("${s3AwsEndpoint}/${postsDisplay.cover}")`,
                        }}
                      ></div>
                      <div className="pb-3">
                        <p className="font-open-sans font-weight-400 font-size-12 text-black my-2">
                          {postsDisplay.created_at}
                        </p>
                        <h4 className="font-all-round font-size-20 font-weight-600 text-black">
                          {strLimit(postsDisplay.title, 70)}
                        </h4>
                        <p className="post-content font-open-sans font-weight-400 font-size-16 text-black">
                          {strLimit(removeHtmlTags(postsDisplay.body), 100)}
                        </p>
                        <div className="d-flex author-section">
                          <img
                            src="/images/blog/avatar.png"
                            alt="..."
                            className="img-fluid rounded"
                          />
                          <div className="d-block pl-3">
                            <div className="author-text">
                              <h5 className="font-open-sans font-weight-600 font-size-14 text-black">
                                {postsDisplay.author.name}
                              </h5>
                              <p className="font-open-sans font-weight-400 font-size-12 text-black">
                                {postsDisplay.minutes_to_read}{' '}
                                {decode(this.state.blogData[5])}
                              </p>
                            </div>
                          </div>
                        </div>
                        <Link
                          to={`/post/${postsDisplay.id}`}
                          className="btn btn-orange font-open-sans font-size-16 font-weight-700 text-white"
                        >
                          {decode(this.state.blogData[4])}
                        </Link>
                      </div>
                    </div>
                  </div>
                )
              })
            ) : (
              <div className="col-12">
                <p className="font-open-sans font-size-14 font-weight-400">
                  {decode(this.state.blogData[6])}
                </p>
              </div>
            )}
          </div>
        </div>
      </section>
    )
  }
}

export default withAuth(Blog)
// export default withBlog(Blog);
